import { createContext, useContext, useEffect, useState } from "react";
import api, { setToken, clearToken, getToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (!getToken()) { setUser(false); setChecked(true); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => { clearToken(); setUser(false); })
      .finally(() => setChecked(true));
  }, []);

  const staffLogin = async (password) => {
    const { data } = await api.post("/auth/staff-login", { password });
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    clearToken();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, checked, staffLogin, logout, isAdmin: user && user.role === "admin", isPharmacist: user && (user.role === "pharmacien" || user.role === "admin") }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
